import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconMergeConflict: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMergeConflict"><Circle cx="6.5" cy="17.5" r="2" stroke="currentColor" strokeLinecap="square"/><Circle cx="17.5" cy="17.5" r="2" stroke="currentColor" strokeLinecap="square"/><Path d="M6.5 10.5V15.5" stroke="currentColor" strokeLinecap="square"/><Path d="M10.5 6.5H17.5V15.5" stroke="currentColor" strokeLinecap="square"/><Path d="M4.5 4.5L8.5 8.5M8.5 4.5L4.5 8.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconMergeConflict;
